import styled from "styled-components";

import { stylesGlobalDefault } from "../../global/globalStyle";

export const BoxWebCamImage = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 20px;
  padding-top: 0px;
  border-radius: 50%;
`;

export const WebCamContainer = styled.span`
  img,
  video {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
  }
`;

export const ButtonTakePhoto = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${stylesGlobalDefault.white};
  font-size: 20px;
  height: 40px;

  position: relative;
  padding-top: 0px;
  margin-top: -40px;
  margin-right: -120px;

  cursor: pointer;

  img.camera-icon {
    height: 40px;
    width: 40px;
    border-radius: 50px;
    background-color: white;

    @media (max-width: 1600px) {
      height: 30px;
      width: 30px;

      margin-top: 10px;
      margin-right: 50px;
    }
  }
`;

export const avatarStyle = {
  height: 150,
  width: 150,
  borderRadius: "50%",
  objectFit: "cover",
};
